var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreateLayout',{attrs:{"title":"ساخت برند","submitFunction":_vm.createBrand}})
}
var staticRenderFns = []

export { render, staticRenderFns }